export const localeIds = ['en', 'es', 'de'];
